import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=3555ac7d&scoped=true&"
import script from "./FlipBook.vue?vue&type=script&lang=js&"
export * from "./FlipBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3555ac7d",
  null
  
)

export default component.exports